import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import NodeDashboard from "@/pages/NodeDashboard";
import CompanyDashboard from "@/pages/CompanyDashboard";
import SharePage from "@/pages/SharePage";
import Login from "@/pages/Login";
import { AuthProvider, ProtectedRoute } from "@/components/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/share/:token" element={<SharePage />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Overview />} />
            <Route path="/division/:id" element={<NodeDashboard level="division" />} />
            <Route path="/zona/:id" element={<NodeDashboard level="zona" />} />
            <Route path="/regional/:id" element={<NodeDashboard level="regional" />} />
            <Route path="/company/:id" element={<CompanyDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
